/**
 * Extra scroll stack — sticky pin + progress-driven stacked wipe.
 * While pinned, scroll advances slides over each other; rest of page waits below.
 */
(function () {
  'use strict';

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function easeInOut(t) {
    return t * t * (3 - 2 * t);
  }

  function initStack(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-extra-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-extra-dot]'));
    var count = slides.length;
    if (count < 1) return;

    var activeIndex = 0;
    var ticking = false;
    var smooth = 0;
    var target = 0;
    var rafId = 0;

    slides.forEach(function (slide, i) {
      slide.style.transform = i === 0 ? 'translate3d(0, 0%, 0)' : 'translate3d(0, 100%, 0)';
      slide.style.zIndex = String(i + 1);
    });

    function setDots(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    // Fraction of each transition segment spent actually wiping.
    // The rest is a "hold" where the arrived slide stays put before the
    // next one begins — so each slide finishes, waits, then the next starts.
    var MOVE_RATIO = 0.78;

    function applyProgress(progress) {
      var transitions = Math.max(1, count - 1);
      var raw = clamp(progress, 0, 1) * transitions;
      var from = Math.min(transitions - 1, Math.floor(raw));
      var within = clamp(raw - from, 0, 1);
      var local = within <= MOVE_RATIO ? within / MOVE_RATIO : 1;
      var eased = easeInOut(clamp(local, 0, 1));

      slides.forEach(function (slide, i) {
        var y;
        if (i <= from) {
          y = 0;
        } else if (i === from + 1) {
          y = (1 - eased) * 100;
        } else {
          y = 100;
        }
        slide.style.transform = 'translate3d(0, ' + y + '%, 0)';
      });

      var index = eased > 0.5 ? from + 1 : from;
      index = clamp(index, 0, count - 1);
      if (progress >= 0.999) index = count - 1;

      if (index !== activeIndex) {
        activeIndex = index;
        setDots(index);
      }
    }

    function measureTarget() {
      var rect = root.getBoundingClientRect();
      var total = root.offsetHeight - window.innerHeight;
      if (total <= 0) {
        target = 0;
      } else {
        target = clamp(-rect.top, 0, total) / total;
      }
      var inStack = rect.top <= 1 && rect.bottom >= window.innerHeight - 1;
      document.documentElement.classList.toggle('extra-stack-locking', inStack);
    }

    function tick() {
      ticking = false;
      measureTarget();
      // Smooth scrub so wheel feels less jumpy
      smooth += (target - smooth) * 0.18;
      if (Math.abs(target - smooth) < 0.0005) smooth = target;
      applyProgress(smooth);
      if (smooth !== target) {
        rafId = window.requestAnimationFrame(tick);
        ticking = true;
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        rafId = window.requestAnimationFrame(tick);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measureTarget();
    smooth = target;
    applyProgress(smooth);
  }

  function boot() {
    document.querySelectorAll('[data-extra-scroll-stack]').forEach(initStack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
